export default "__VITE_ASSET__DsSPYYYc__"